export default function LegalPage({ title, updated = '13 de agosto de 2026', children }) {
  return (
    <article className="mx-auto max-w-4xl px-6 py-12 lg:py-16">
      <p className="mb-2 text-sm font-medium uppercase tracking-wider text-emerald-700">AEA · Espacio de Datos</p>
      <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
      <p className="mt-3 text-sm text-slate-500">Última actualización: {updated}</p>
      <div className="mt-10 space-y-8 leading-7 text-slate-700 [&_a]:text-emerald-700 [&_a]:underline [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-slate-900 [&_li]:ml-5 [&_li]:list-disc [&_p]:mt-3">{children}</div>
    </article>
  );
}
